import axios from 'axios';
import { isNative, getToken, clearToken } from './authToken';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  // Web relies on the same-origin HttpOnly session cookie (no JS-readable
  // token anywhere). Native attaches a Bearer token from secure storage.
  withCredentials: !isNative,
});

api.interceptors.request.use(async (config) => {
  if (isNative) {
    const token = await getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Handle 401 responses globally
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      await clearToken();
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export { API_URL };
